import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { useState, useEffect } from 'react';

const homeBounds = {
  minLat: 45.530840, maxLat: 45.531990,
  minLng: -122.681375, maxLng: -122.680382,
};

const vegasBounds = {
  minLat: 35.873472, maxLat: 36.346103,
  minLng: -115.484161, maxLng: -114.698639,
};

const defconBounds = {
  minLat: 36.1315, maxLat: 36.1368,
  minLng: -115.1639, maxLng: -115.1527,
};

function inBounds(lat, lng, bounds) {
  return lat >= bounds.minLat && lat <= bounds.maxLat &&
         lng >= bounds.minLng && lng <= bounds.maxLng;
}

function speedEmoji(speed) {
  if (speed == null || speed <= 0) return "🧍";
  if (speed <= 2) return "🚶";
  if (speed <= 6) return "🏃";
  return "🚋";
}

function Header(props) {
  const queryClient = useQueryClient();
  const [emoji, setEmoji] = useState(null);

  useEffect(() => {
    function update() {
      const samples = queryClient.getQueryData("current");
      if (!samples || samples.length === 0) return;
      const latest = samples[0];
      const { latitude, longitude, altitude, speed } = latest;
      if (latitude == null || longitude == null) return;

      if (altitude > 1000) {
        setEmoji("✈️");
      } else if (inBounds(latitude, longitude, homeBounds)) {
        setEmoji("🏠");
      } else if (inBounds(latitude, longitude, defconBounds)) {
        setEmoji("🏴‍☠️");
      } else if (inBounds(latitude, longitude, vegasBounds)) {
        setEmoji("🎰");
      } else {
        setEmoji(speedEmoji(speed));
      }
    }

    update();
    const unsub = queryClient.getQueryCache().subscribe(update);
    return () => unsub();
  }, [queryClient]);

  return (
    <Navbar bg="dark" variant="dark" className="flex-nowrap">
      {/* min-width lets the long brand ellipsize on a phone instead of shoving
          the nav off the edge */}
      <Navbar.Brand as={Link} to="/" className="text-truncate" style={{ minWidth: 0 }}>
        Where is Eric at Defcon?
      </Navbar.Brand>
      <Nav className="flex-row align-items-center flex-shrink-0 mr-auto">
        <Nav.Link as={Link} to="/dc34" className="px-2 text-nowrap">DC34</Nav.Link>
      </Nav>
      {emoji && (
        <span className="flex-shrink-0 pl-2" style={{ fontSize: '1.75rem', lineHeight: 1 }}>
          {emoji}
        </span>
      )}
    </Navbar>
  );
}

export default Header;
